module.exports = "/fonts/assistant-hebrew.woff2?583f9bddda2f13a3a86358915dddc6b6";